// extracted by mini-css-extract-plugin
module.exports = {"meta":"B_P","card":"B_c"};